<template>

<div class="bg-secondary py-5">

        <inertia-head title="Confirm Password">
        </inertia-head>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col" style="max-width: 360px;">
                    <div class="card rounded-3 shadow border-0">
                        <div class="card-header border-0">{{ __('Confirm Password') }}</div>

                        <div class="card-body">

                            <p>
                                {{ __('Please confirm your password before continuing.') }}
                            </p>

                            <form @submit.prevent="form.post(route('password.confirm'))">
                                <text-input type="password" :floating="true" label="password" v-model="form.password" :error="form.errors.password" autocomplete="current-password" autofocus />
                                <submit-button :label="__('Confirm Password')" child-class="w-100" />
                            </form>           

                            <div v-if="route().has('password.request')">
                                <hr />
                                <inertia-link :href="route('password.request')">
                                    {{ __('Forgot Your Password?') }}
                                </inertia-link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import SlimLayout from '@/shared/Layouts/SlimLayout';

    import TextInput from '@/shared/Inputs/TextInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        layout: SlimLayout,
        props: {
        },
        data() {
            return {
                form: this.$inertia.form({
                    email: null,
                    password: null,
                    remember: null,
                }),
            }
        },
        components: {
            TextInput,
            CheckboxInput,
            SubmitButton,
        },
        computed: {
        },
    }
</script>
